<template>
<div>
    <v-flex xs12 sm6 md6 lg6 offset-lg3 offset-sm3 offset-md3 mt-3>
        <!-- Alert -->
        <Alert :atype="alertType" :message="message" :visibility="visibility" />

        <v-progress-linear v-if="progressbar" :indeterminate="true"></v-progress-linear>

        <v-card class="semi-transparent-5-bg v-card__text" width="100%" style="display: flex; justify-content: center; align-items: center; flex-direction: column;">

            <Logo style="display: flex; flex-direction: column;align-items: center"/>

            <v-form ref="form" v-model="valid" lazy-validation style="width: 80%;">

                <v-text-field id="usernameField" single-line box autofocus background-color="#7575757d" class="borderlessInput usernameField" v-model="username" :rules="usernameRules" :label=" $t( 'user_management.username' )" required></v-text-field>

                <v-text-field id="passwordField" single-line box autofocus background-color="#7575757d"  class="borderlessInput passwordField" v-model="password" :rules="passwordRules" :label="$t( 'user_management.password' )" :type="'password'" required></v-text-field>

                <div style="display:flex; justify-content: center;" class="mt-2 mb-2">
                    <v-btn color="primary" @click.prevent="validate" :disabled="!valid" style="width:100%;">
                        {{  $t( 'user_management.login' ) }}
                    </v-btn>

                    <!-- <v-btn color="#004D40" to="/register">
                        {{  $t( 'user_management.register' ) }}
                    </v-btn> -->
                </div>

                <v-container>
                    <!-- <strong>
                        <router-link :to="{ name: 'Forgot Password'}">
                            Forgot Password?
                        </router-link>
                    </strong> -->
                </v-container>
            </v-form>
        </v-card>

        <span class="mt-2 registerLink">
            <span style="color: #666;">Dont have an account? &nbsp;</span>
            <router-link :to="{ name: 'Register'}">
                <strong>Signup here</strong>
            </router-link>
        </span>

    </v-flex>
</div>
</template>

<script>
import Alert from "@/components/Reusable/Alert.vue";
import Logo from "@/components/Layout/Logo.vue";
import Api from "@/api";


export default {

    name: 'login',
    data() {
        return {
            valid: true,
            username: "",
            // usernameRules: [
            //     v => !!v || this.$t( 'user_management.user_validation_rule' )
            // ],
            password: "",
            // passwordRules: [
            //     v => !!v || this.$t( 'user_management.pass_validation_rule' )
            // ],
            alertType: "",
            message: "",
            visibility: "",
            progressbar: false,
        }
    },
    components: {
        Alert,
        Logo
    },
    mounted: function() {

        $('input[type=text]').focus(function() {

            let targetParentId = null;

            targetParentId = $(this).attr('id');

           focusFormFieldAnimation(targetParentId);

        });

        $('input[type=text]').focusout(function() {

            let targetParentId = null;

            targetParentId = $(this).attr('id');

            unfocusFormFieldAnimation(targetParentId);

        });

        $('input[type=password]').focus(function() {

            let targetParentId = null;

            let targetParentClass = null;

            targetParentId = $(this).attr('id');

            focusFormFieldAnimation(targetParentId);

        });

        $('input[type=password]').focusout(function() {

            let targetParentId = null;

            targetParentId = $(this).attr('id');

            unfocusFormFieldAnimation(targetParentId);

        });

        function focusFormFieldAnimation(targetParentId) {

            let targetParentClass = null;

            targetParentClass = $('.' + targetParentId + ' .v-input__control .v-input__slot');

            targetParentClass.css('text-shadow','0px 0px 2px #ccc');

            targetParentClass.css('box-shadow','0 0 2px #fff, 0 0 5px #fff, 0 0 10px #fff');

            targetParentClass.css('transition-delay','0.1s');
        }

        function unfocusFormFieldAnimation(targetParentId) {

            let targetParentClass = null;

            targetParentClass = $('.' + targetParentId + ' .v-input__control .v-input__slot');

            targetParentClass.css('text-shadow','');

            targetParentClass.css('box-shadow','');

            targetParentClass.css('transition-delay','');
        }
    },
    computed : {
        usernameRules() {
            return [
                v => !!v || this.$t( 'user_management.user_validation_rule' )
            ]
        },
        passwordRules() {
            return [
                v => !!v || this.$t( 'user_management.pass_validation_rule' )
            ]
        }
    },
    methods: {
        resetAlert() {
            this.visibility = false;
            this.message = "";
            this.alertType = "";
            this.progressbar = false;
        },
        async validate() {
            this.resetAlert();
            this.progressbar = true;
            if (this.$refs.form.validate()) {
                let res = await Api.postLogin({
                    username: this.username,
                    password: this.password,
                    token: this.$store.getters.browser_identity
                });
                this.progressbar = false;

                if (res && 'success' in res && res.success == true) {
                    this.$store.dispatch('toggleLogin', true);
                    this.$store.dispatch('login', res.data);
                   this.$router.push({
                        name: "home"
                    });
                } else {
                    this.visibility = true;
                    this.message = res.message;
                    this.alertType = "error";
                }
            }else{
                this.progressbar = false;
            }
        },
    }
}

</script>

<style scoped>
.v-card__text {
    padding: 7px;
}

.v-form > .container {
    padding: 10px;
}

.registerLink {
    position: absolute;
    bottom: 0px;
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
    text-align: center;
    margin-top: 10px;
    margin-bottom: 10px;
}

</style>

<style>

.borderlessInput .v-input__control .v-input__slot:before {
    border-style: none !important;
}
</style>